export enum Device {
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
  Unknown = 'unknown',
}

export enum TimeRange {
  Today = 'today',
  Yesterday = 'yesterday',
  LastDay = 'last_day',
  LastWeek = 'last_week',
  LastSevenDays = 'last_7_days',
  LastFourteenDays = 'last_14_days',
  LastThirtyDays = 'last_30_days',
  LastMonth = 'last_1_month',
  LastThreeMonths = 'last_three_months',
  LastSixMonths = 'last_6_months',
  LastTwelveMonths = 'last_12_months',
  LastYear = 'last_1_year',
  LastFiveYears = 'last_5_year',
  LastTenYears = 'last_10_year',
  LastThreeYears = 'last_3_years',
}

export interface TrafficByDeviceType {
  key: string
  percentage: number
  count: number
}

export interface UsersPercentagePerCountry {
  key: string
  percentage: number
}

export interface Metric {
  key: string
  values: number[]
}

export interface HotspotHistory {
  timestamps: string[]
  metrics: Metric[]
}

export interface TrafficData {
  network_type: string
  upload: number
  download: number
}

export interface SsidData {
  name: string
  traffic: TrafficData
  color: string
}

export interface SSIDPercentage {
  upload: number
  download: number
  total: number
}

export interface SSID {
  color?: string
  network_name: string
  upload: number
  download: number
  name: string
  percentage: number
}

export interface Total {
  upload: number
  download: number
  total: number
}

export interface GraphDataByType {
  timestamp: string
  dateTime: string
  private: number
  guest: number
  other: number
}

export interface GraphDataBySsid {
  timestamp: string
  dateTime: string
}
